import cx from 'classnames';

import {Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {HeadingRecentProps} from './HeadingRecent.types';

import {
  recentOrdersTextHeadingAccordion,
  recentOrdersTextHeadingAccordionText,
  recentOrdersTextHeadingAccordionTextGrow,
  recentOrdersTextHeadingAccordionTextHidden,
  recentOrdersTextHeadingAccordionTextInner,
  recentOrdersTextHeadingText,
} from './RecentOrders.css';

const HeadingRecent = ({
  heading1,
  heading2,
  heading3,
  heading4,
  isAccordion = true,
}: HeadingRecentProps) => {
  return (
    <div
      className={sprinkles({flex: 'flex', dir: 'col', gap: 20, width: 'full', content: 'between'})}>
      <div className={recentOrdersTextHeadingAccordion}>
        <Text
          variant="body"
          color={isAccordion ? 'mineShaft' : 'dustyGray'}
          className={
            isAccordion ? recentOrdersTextHeadingAccordionText : recentOrdersTextHeadingText
          }>
          {heading1}
        </Text>
        <Text
          variant="body"
          color={isAccordion ? 'mineShaft' : 'dustyGray'}
          className={cx(
            isAccordion ? recentOrdersTextHeadingAccordionText : recentOrdersTextHeadingText,
            recentOrdersTextHeadingAccordionTextGrow,
          )}>
          {heading2}
        </Text>
        <Text
          variant="body"
          color={isAccordion ? 'mineShaft' : 'dustyGray'}
          className={cx(
            isAccordion ? recentOrdersTextHeadingAccordionText : recentOrdersTextHeadingText,
            recentOrdersTextHeadingAccordionTextHidden,
          )}>
          {heading3}
        </Text>
        <Text
          variant="body"
          color={isAccordion ? 'mineShaft' : 'dustyGray'}
          className={cx(
            isAccordion ? recentOrdersTextHeadingAccordionText : recentOrdersTextHeadingText,
            recentOrdersTextHeadingAccordionTextInner,
          )}>
          {heading4}
        </Text>
      </div>
    </div>
  );
};

export default HeadingRecent;
